import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { AxiosWrapper } from 'services/AxiosWrapper';
import { ItineraryManagerApiService } from 'services/ItineraryManagerApi';
import { useNotifications } from 'hooks/useNotifications';

export const useVoucherEditQueries = (
  itineraryManagerApi: ItineraryManagerApiService<AxiosWrapper<AxiosInstance>>,
  voucherUuid: string | undefined
) => {
  const queryClient = useQueryClient();
  const notifications = useNotifications();

  const saveVoucher = useMutation({
    mutationFn: async (voucherData: any) => {
      if (!voucherUuid) {
        throw new Error('Voucher UUID is required');
      }
      return itineraryManagerApi.saveVoucher(voucherUuid, voucherData);
    },
    onSuccess: () => {
      // Invalidate the voucher view query to refetch fresh data
      queryClient.invalidateQueries({ queryKey: ['getVouchersV2View', voucherUuid] });
    },
    onError: (error) => {
      console.error('Error saving voucher:', error);
      notifications.showErrorNotification('Failed to save voucher. Please try again.');
    },
  });

  return {
    saveVoucher,
  };
};